/* =====================================================================
   PB UGENS SPIN — medlemmernes ugentlige hjul (sections/pb-mwheel-page.liquid · pb-server mwheel.js).
   • Ét spin pr. medlem pr. uge (ny uge mandag). Serveren trækker feltet og udbetaler gevinsten — her drejer hjulet og
     lander præcis på det felt. Felterne ER chancerne: hver gevinst fylder sine felter ud af hele hjulet.
   • Siden spørger /apps/pb/mw (Shopify bekræfter kunden). Mystery-gaven: vælg brand → lægges i kurven til 0 kr.
   • Tekster: temaets sprogfiler (mwheel.*) via <script data-pb-mw-t>.
   ===================================================================== */
(function () {
  'use strict';
  var d = document, w = window, root = d.querySelector('[data-pb-mw]');
  if (!root) return;
  var T = {}; try { T = JSON.parse(d.querySelector('[data-pb-mw-t]').textContent); } catch (e) {}
  /* Shopifys t-filter HTML-escaper teksterne (It's → It&#39;s): afkodes én gang her — de escapes igen med esc(), når de sættes som HTML */
  (function () { var x = d.createElement('textarea'); for (var k in T) if (typeof T[k] === 'string' && T[k].indexOf('&') > -1) { x.innerHTML = T[k]; T[k] = x.value; } })();
  /* giveawayernes navne på kundens sprog (handle → titel fra temaet) — serveren kender kun kildesproget */
  var GW = {}; try { GW = JSON.parse(d.querySelector('[data-pb-mw-gw]').textContent) || {}; } catch (e) {}
  var lang = d.documentElement.lang || 'da', cur = root.getAttribute('data-cur') || 'DKK';
  var cv = root.querySelector('[data-pb-mw-wheel]'), ptr = root.querySelector('[data-pb-mw-pointer]');
  var rev = root.querySelector('[data-pb-mw-reveal]'), burst = root.querySelector('[data-pb-mw-burst]');
  var side = root.querySelector('[data-pb-mw-side]'), oddsEl = root.querySelector('[data-pb-mw-odds]');
  var winsEl = root.querySelector('[data-pb-mw-wins]'), winsBox = root.querySelector('[data-pb-mw-winsbox]');
  var S = null, busy = false, rot = 0, off = d.createElement('canvas'), shown = [], shownHi = -1, spunId = 0;

  function t(k, o) { return String(T[k] == null ? '' : T[k]).replace(/\[(\w+)\]/g, function (m, x) { return o && o[x] != null ? o[x] : m; }); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(a, c) { try { return new Intl.NumberFormat(lang, { style: 'currency', currency: c, maximumFractionDigits: a % 1 ? 2 : 0 }).format(a); } catch (e) { return a + ' ' + c; } }
  function day(iso, wd) { try { return new Intl.DateTimeFormat(lang, wd ? { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' } : { day: 'numeric', month: 'long', timeZone: 'UTC' }).format(new Date(String(iso).slice(0, 10) + 'T12:00:00Z')); } catch (e) { return iso; } }
  function ico(n) { var x = d.querySelector('[data-pb-mw-ico="' + n + '"]'); return x ? x.innerHTML : ''; }
  function gwName(x) { return (x && x.gwh && GW[x.gwh]) || (x && x.gw) || ''; }
  function keys(L) { return String(L || '').split(',').filter(Boolean); }
  function reduced() { return w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  /* =================== GEVINSTERNE (tekster + farver) =================== */
  /* én farve pr. gevinst (rækkens plads i opsætningen) — samme farve på hjulet og i chancelisten; nitter er mørke */
  var PAL = [['#f4c21d', '#15172e'], ['#c39bff', '#1a0d33'], ['#2dd4bf', '#062925'], ['#3b82f6', '#ffffff'], ['#ef4444', '#ffffff'], ['#f97316', '#1f0d00'], ['#22c55e', '#052e16'], ['#6b46e5', '#ffffff']];
  var NIT = ['#0d0e26', '#8486bd'];
  function shade(hex, f) {
    var v = parseInt(hex.slice(1), 16), m = function (c) { return Math.round(f < 0 ? c * (1 + f) : c + (255 - c) * f); };
    return '#' + ((1 << 24) + (m(v >> 16) << 16) + (m(v >> 8 & 255) << 8) + m(v & 255)).toString(16).slice(1);
  }
  function colOf(i) {
    var base = PAL[i % PAL.length], lvl = Math.floor(i / PAL.length) % 3; if (!lvl) return base;
    var bg = shade(base[0], [0, -0.38, 0.4][lvl]), v = parseInt(bg.slice(1), 16);
    return [bg, (0.299 * (v >> 16) + 0.587 * (v >> 8 & 255) + 0.114 * (v & 255)) / 255 > 0.55 ? '#15172e' : '#ffffff'];
  }
  function rows() { return (S && S.wheel && S.wheel.rows) || []; }
  function colKey(k) { return k === 'n' ? NIT : colOf(Number(k) - 1); }
  /* gevinstens navn (chancelisten, listen over gevinster) */
  function prize(x) {
    if (!x || x.k === 'nit' || x.kind === 'nit') return t('p_nit');
    var k = x.k || x.kind;
    if (k === 'cb') return t('p_cb', { a: money(x.a, x.cur) });
    if (k === 'code') return t('p_code', { p: x.pct });
    return t('p_' + k);
  }
  /* kort tekst på hjulets felter (kun når feltet er bredt nok) */
  function short(k) {
    if (k === 'n') return t('p_nit');
    var r = rows()[Number(k) - 1]; if (!r) return '';
    if (r.k === 'cb') return money(r.a, r.cur);
    if (r.k === 'code') return r.pct + ' %';
    return t('s_' + r.k);
  }

  /* =================== HJULET =================== */
  /* tegnes én gang på et skjult lærred og drejes ved at tegne det roteret (et CSS-roteret lærred giver rullebjælker) */
  function paint() {
    var c = cv.getContext('2d'), W = cv.width; if (!W) return;
    c.setTransform(1, 0, 0, 1, 0, 0); c.clearRect(0, 0, W, W);
    c.translate(W / 2, W / 2); c.rotate(rot * Math.PI / 180); c.drawImage(off, -W / 2, -W / 2);
  }
  function fit(c, txt, fs, maxW) {
    c.font = '800 ' + fs + 'px Nunito, system-ui, sans-serif';
    var tw = c.measureText(txt).width;
    if (tw > maxW) { fs = Math.max(10, fs * maxW / tw); c.font = '800 ' + fs + 'px Nunito, system-ui, sans-serif'; tw = c.measureText(txt).width; }
    if (tw > maxW) { var s = txt; while (s.length > 1 && c.measureText(s + '…').width > maxW) s = s.slice(0, -1); txt = s.replace(/\s+$/, '') + '…'; }
    return txt;
  }
  function draw(L, hi) {
    shown = L || []; shownHi = hi == null ? -1 : hi;
    var css = cv.clientWidth || 480, dpr = Math.min(2, w.devicePixelRatio || 1);
    cv.width = off.width = Math.round(css * dpr); cv.height = off.height = Math.round(css * dpr);
    var c = off.getContext('2d'); c.setTransform(dpr, 0, 0, dpr, 0, 0); c.clearRect(0, 0, css, css);
    var r = css / 2, n = Math.max(1, shown.length), seg = Math.PI * 2 / n, a0 = -Math.PI / 2;
    var arcPx = seg * r * 0.8, fsCap = Math.min(30, Math.max(14, r * 0.075)), outer = r - 24, maxW = outer - r * 0.24;
    for (var i = 0; i < n; i++) {
      var k = shown[i] || 'n', col = colKey(k);
      c.beginPath(); if (n > 1) c.moveTo(r, r);
      c.arc(r, r, r - 12, a0 + i * seg, a0 + (i + 1) * seg); if (n > 1) c.closePath();
      c.fillStyle = i === shownHi ? shade(col[0], 0.3) : col[0]; c.fill();
      if (n > 1 && n <= 120) { c.strokeStyle = 'rgba(0,0,0,.22)'; c.lineWidth = 1; c.stroke(); }
      if (arcPx >= 14) {
        c.save(); c.translate(r, r); c.rotate(a0 + (i + 0.5) * seg); c.fillStyle = col[1]; c.textAlign = 'right'; c.textBaseline = 'middle';
        c.fillText(fit(c, short(k), Math.max(10, Math.min(fsCap, arcPx * 0.6)), maxW), outer, 0); c.restore();
      }
    }
    if (shownHi >= 0 && shownHi < n) {   /* vinderfeltet: hvid kant, så det kan ses, også når felterne er smalle */
      c.save(); c.beginPath(); if (n > 1) c.moveTo(r, r); c.arc(r, r, r - 12, a0 + shownHi * seg, a0 + (shownHi + 1) * seg); if (n > 1) c.closePath();
      c.shadowColor = 'rgba(255,255,255,.95)'; c.shadowBlur = 14; c.strokeStyle = '#fff'; c.lineWidth = n > 60 ? 2.5 : 3; c.lineJoin = 'round'; c.stroke(); c.restore();
    }
    c.beginPath(); c.arc(r, r, r - 7, 0, Math.PI * 2); c.lineWidth = 11; c.strokeStyle = '#f4c21d'; c.stroke();
    c.beginPath(); c.arc(r, r, r - 12.5, 0, Math.PI * 2); c.lineWidth = 2; c.strokeStyle = 'rgba(0,0,0,.35)'; c.stroke();
    for (var b = 0; b < 24; b++) { var a = b / 24 * Math.PI * 2; c.beginPath(); c.arc(r + Math.cos(a) * (r - 7), r + Math.sin(a) * (r - 7), 2.8, 0, Math.PI * 2); c.fillStyle = b % 2 ? '#fff6cc' : '#ffffff'; c.fill(); }
    paint();
  }
  w.addEventListener('resize', function () { if (!busy && shown.length) draw(shown, shownHi); });

  /* =================== LYD (frivillig — samme lydbillede som de andre hjul) =================== */
  var A = null, sound = false, lastVis = 0;
  try { sound = w.localStorage.getItem('pb-mw-sound') === '1'; } catch (e) {}
  function audio() {
    if (A) return A;
    var C = w.AudioContext || w.webkitAudioContext; if (!C) return null;
    var c = new C(), comp = c.createDynamicsCompressor(), master = c.createGain();
    comp.threshold.value = -16; comp.ratio.value = 5; master.gain.value = 0.9; master.connect(comp); comp.connect(c.destination);
    var len = c.sampleRate, buf = c.createBuffer(1, len, c.sampleRate), ch = buf.getChannelData(0);
    for (var i = 0; i < len; i++) ch[i] = Math.random() * 2 - 1;
    A = { c: c, out: master, noise: buf, last: 0 }; return A;
  }
  function env(g, at, peak, a, dcy) { g.gain.setValueAtTime(0.0001, at); g.gain.exponentialRampToValueAtTime(peak, at + a); g.gain.exponentialRampToValueAtTime(0.0001, at + a + dcy); }
  function tick(speed) {
    var now = performance.now();
    if (now - lastVis > 45 && ptr) { lastVis = now; ptr.classList.remove('is-tick'); void ptr.offsetWidth; ptr.classList.add('is-tick'); }
    if (!sound || !A) return;
    var c = A.c, at = c.currentTime; if (at - A.last < 0.032) return; A.last = at;
    var o = c.createOscillator(), g = c.createGain(); o.type = 'triangle'; o.frequency.setValueAtTime(900 + 400 * (1 - speed), at); o.frequency.exponentialRampToValueAtTime(420, at + 0.04);
    env(g, at, 0.14 + 0.12 * (1 - speed), 0.002, 0.05); o.connect(g); g.connect(A.out); o.start(at); o.stop(at + 0.07);
  }
  function landed() {
    if (!sound || !A) return;
    var c = A.c, at = c.currentTime + 0.02;
    [523.25, 659.25, 783.99, 1046.5].forEach(function (f, i) { var t0 = at + i * 0.11, o = c.createOscillator(), g = c.createGain(); o.type = 'sawtooth'; o.frequency.value = f; env(g, t0, i === 3 ? 0.14 : 0.08, 0.02, i === 3 ? 1.1 : 0.3); o.connect(g); g.connect(A.out); o.start(t0); o.stop(t0 + 1.3); });
  }
  function blank() {
    if (!sound || !A) return;
    var c = A.c, at = c.currentTime + 0.02;
    [392, 349.2, 311.1].forEach(function (f, i) { var t0 = at + i * 0.24, o = c.createOscillator(), g = c.createGain(); o.type = 'triangle'; o.frequency.value = f; env(g, t0, 0.12, 0.02, i === 2 ? 0.7 : 0.2); o.connect(g); g.connect(A.out); o.start(t0); o.stop(t0 + 0.9); });
  }
  function soundBtn() { return '<button type="button" class="pb-mw__sound' + (sound ? ' is-on' : '') + '" data-pb-mw-sound aria-pressed="' + sound + '">' + ico('bell') + '<span>' + esc(t('sound')) + '</span></button>'; }
  function confetti() {
    if (!burst || reduced()) return; burst.innerHTML = '';
    var C = ['#f4c21d', '#ef4444', '#3b82f6', '#22c55e', '#c39bff', '#2dd4bf'];
    for (var i = 0; i < 90; i++) { var p = d.createElement('i'); p.style.left = (Math.random() * 100) + '%'; p.style.background = C[i % C.length]; p.style.animationDelay = (Math.random() * 0.4) + 's'; p.style.animationDuration = (2 + Math.random() * 1.4) + 's'; p.style.setProperty('--dx', (Math.random() * 200 - 100) + 'px'); p.style.setProperty('--r', (Math.random() * 900 - 450) + 'deg'); burst.appendChild(p); }
    setTimeout(function () { burst.innerHTML = ''; }, 4200);
  }

  /* =================== SIDEN =================== */
  function p(s, cls) { return '<p class="pb-mw__p' + (cls ? ' ' + cls : '') + '">' + esc(s) + '</p>'; }
  function btn(label, attr, cls) { return '<button type="button" class="pb-mw__btn' + (cls ? ' ' + cls : '') + '" ' + attr + '>' + esc(label) + '</button>'; }
  function link(label, href, cls) { return '<a class="pb-mw__btn' + (cls ? ' ' + cls : '') + '" href="' + esc(href) + '">' + esc(label) + '</a>'; }
  /* resultatet af et spin: overskrift + forklaring (+ kode / gave) */
  function result(s, big) {
    var h = '', x = '';
    if (s.kind === 'nit') { h = t('r_nit'); x = t('r_nit_d', { date: day(S.next, true) }); }
    else if (s.state === 'retry' || s.state === 'pay') { h = prize(s); x = t('r_wait'); }
    else if (s.kind === 'cb') { h = t('r_cb', { a: money(s.a, s.cur) }); x = t('r_cb_d'); }
    else if (s.kind === 'code') { h = t('r_code', { p: s.pct }); x = t('r_code_d', { date: day(s.until) }); }
    else if (s.kind === 'lod') { h = t('r_lod'); x = gwName(s) ? t('r_lod_d', { gw: gwName(s) }) : t('r_lod_next'); }
    else if (s.kind === 'pw') { h = t('r_pw'); x = t('r_pw_d'); }
    else if (s.kind === 'gift') { h = t('r_gift'); x = t('r_gift_d', { date: day(s.until) }); }
    return big ? { h: h, x: x } : '<div class="pb-mw__res' + (s.kind === 'nit' ? ' is-nit' : '') + '"><span>' + esc(s.kind === 'nit' ? t('this_week') : t('won')) + '</span><b>' + esc(h) + '</b>' + p(x) + (s.kind === 'code' && s.code ? codeBox(s.code) : '') + '</div>';
  }
  function codeBox(code) { return '<div class="pb-mw__code"><code>' + esc(code) + '</code><button type="button" class="pb-mw__copy" data-pb-mw-copy="' + esc(code) + '">' + esc(t('copy')) + '</button></div>'; }
  /* mystery-gaver der venter: vælg brand → i kurven */
  function giftPending() {
    var today = S.today || new Date().toISOString().slice(0, 10);
    return (S.wins || []).filter(function (x) { return x.kind === 'gift' && !x.used && x.until >= today && x.state !== 'retry'; });
  }
  /* noUntil: ugens gave står allerede som resultat ovenover (med fristen) — så står fristen der ikke to gange */
  function giftBox(g, noUntil) {
    var b = S.brands || [];
    if (!b.length) return '<div class="pb-mw__gift">' + p(t('none_left'), 'pb-mw__fine') + '</div>';
    return '<div class="pb-mw__gift" data-pb-mw-gift="' + g.id + '"><p class="pb-mw__lbl">' + esc(t('brand')) + '</p><div class="pb-mw__brands" role="radiogroup" aria-label="' + esc(t('brand')) + '">' +
      b.map(function (x, i) { var on = g.v ? g.v === x.id : i === 0; return '<label class="pb-mw__chip"><input type="radio" name="pb-mw-brand-' + g.id + '" value="' + x.id + '"' + (on ? ' checked' : '') + '><span>' + esc(x.title) + '</span></label>'; }).join('') +
      '</div>' + btn(t('gift_btn'), 'data-pb-mw-addgift="' + g.id + '"') + (noUntil ? '' : '<p class="pb-mw__fine">' + esc(t('gift_until', { date: day(g.until) })) + '</p>') + '</div>';
  }
  function inCartBox() { return p(t('gift_in')) + '<a class="pb-mw__btn" data-pb-mw-gocart href="' + esc(root.getAttribute('data-cart')) + '">' + esc(t('go_cart')) + '</a>'; }
  /* gaven ligger allerede i kurven (fx når siden åbnes igen) → "Gaven ligger i kurven" i stedet for knappen. Brandene står
     der stadig: vælger kunden et andet, kommer knappen igen (og gaven byttes i kurven).
     Samme regel som kassen: et stk. pr. krav, og fødselsdagsgaven bruger et stk. af samme brand først. */
  function inCart(box, on) {
    var b = box.querySelector('[data-pb-mw-addgift]'), x = box.querySelector('[data-pb-mw-in]');
    if (b) b.style.display = on ? 'none' : '';
    if (on && !x) (b || box).insertAdjacentHTML(b ? 'afterend' : 'beforeend', '<div class="pb-mw__in" data-pb-mw-in>' + inCartBox() + '</div>');
    if (!on && x) x.parentNode.removeChild(x);
  }
  function markCart() {
    var mb = (w.PB && PB.cfg && PB.cfg.member) || {}, list = giftPending().filter(function (g) { return g.v; }), today = (S && S.today) || '';
    if (!mb.bg || !list.length) return;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).then(function (c) {
      if (!c) return;
      var q = {}, bc = mb.bc;
      (c.items || []).forEach(function (i) { if (Number(i.product_id) === Number(mb.bg)) q[i.variant_id] = (q[i.variant_id] || 0) + i.quantity; });
      if (bc && bc.c === 'gift' && bc.v && bc.used !== true && (!bc.until || !today || today <= bc.until) && q[bc.v] > 0) q[bc.v]--;
      list.forEach(function (g) {
        if (!(q[g.v] > 0)) return;
        q[g.v]--;
        var box = side.querySelector('[data-pb-mw-gift="' + g.id + '"]'), r = box && box.querySelector('input[type="radio"]:checked');
        if (box && r && Number(r.value) === Number(g.v)) inCart(box, true);
      });
    }).catch(function () {});
  }
  function renderSide() {
    var s = S, h = '';
    if (!s.loggedIn) h = s.on ? p(t('login')) + link(t('login_btn'), root.getAttribute('data-login')) : p(t('off'));
    else if (!s.member) h = p(t('not_member')) + link(t('join'), root.getAttribute('data-member-url'));
    else if (!s.on) h = p(t('off'));
    else if (s.can) h = '<div class="pb-mw__ready"><b>' + esc(t('ready')) + '</b>' + p(t('ready_d')) + '</div>' + btn(t('spin'), 'data-pb-mw-spin', 'pb-mw__btn--big') + (s.test ? testPick() : '');
    else if (s.spin) h = result(s.spin) + (s.spin.kind === 'nit' ? '' : p(t('next', { date: day(s.next, true) }), 'pb-mw__next'));   /* nitten siger selv, hvornår det næste spin er */
    else h = p(t('next', { date: day(s.next, true) }), 'pb-mw__next');
    /* mystery-gaver, der venter på et brand / at blive bestilt (ugens gave står allerede som resultat ovenover) */
    if (s.loggedIn && s.member) giftPending().forEach(function (g) {
      var mine = !!(s.spin && s.spin.id === g.id);
      if (!mine) h += '<div class="pb-mw__gifthead"><span class="pb-mw__gico">' + ico('gift') + '</span><b>' + esc(t('gift_wait')) + '</b></div>';
      h += giftBox(g, mine);
    });
    side.innerHTML = h + soundBtn();
    markCart();
  }
  /* test-kunder (medlemskab test): vælg gevinsten, så hver slags kan prøves af i butikken — serveren tjekker, at kunden er test-kunde */
  function testPick() {
    var seen = {}, o = '<option value="">' + esc(t('test_any')) + '</option>';
    rows().forEach(function (r) {
      if (!r.f || seen[r.k]) return; seen[r.k] = 1;
      var same = rows().filter(function (x) { return x.k === r.k && x.f; });
      var label = r.k === 'cb' ? t('p_cb', { a: same.map(function (x) { return money(x.a, x.cur); }).join(' / ') }) : r.k === 'code' ? t('p_code', { p: same.map(function (x) { return x.pct; }).join(' / ') }) : t('p_' + r.k);
      o += '<option value="' + esc(r.k) + '">' + esc(label) + '</option>';
    });
    if (S.wheel && S.wheel.nit > 0) o += '<option value="nit">' + esc(t('p_nit')) + '</option>';
    return '<label class="pb-mw__test"><span>' + esc(t('test_pick')) + '</span><select data-pb-mw-force>' + o + '</select></label>';
  }
  function renderOdds() {
    var wh = (S && S.wheel) || {}, n = wh.n || 1, list = rows().map(function (r, i) { return { r: r, i: i }; }).filter(function (x) { return x.r.f > 0; });
    var h = list.map(function (x) {
      var c = colOf(x.i)[0], one = Math.max(1, Math.round(n / x.r.f));
      return '<li style="--c:' + c + '"><i></i><span>' + esc(prize(x.r)) + '</span><b>' + esc(t('odds_one', { n: one })) + '</b></li>';
    }).join('');
    if (wh.nit > 0) h += '<li class="is-nit" style="--c:' + NIT[0] + '"><i></i><span>' + esc(t('p_nit')) + '</span><b>' + esc(Math.round(wh.nit / n * 100) + ' %') + '</b></li>';
    oddsEl.innerHTML = h;
  }
  function winLine(x) {
    var today = S.today || '', st = '', extra = '';
    if (x.state === 'retry' || x.state === 'pay') st = t('r_wait');
    else if (x.kind === 'cb') st = t('s_cb');
    else if (x.kind === 'code') { st = x.until && x.until < today ? t('expired') : t('until', { date: day(x.until) }); if (!(x.until && x.until < today)) extra = codeBox(x.code); }
    else if (x.kind === 'lod') st = gwName(x) || t('r_lod_next');
    else if (x.kind === 'pw') st = x.used ? (x.prize ? t('pw_done', { p: x.prize }) : t('pw_nit')) : t('pw_wait');
    else if (x.kind === 'gift') st = x.used ? t('gift_done') : x.until < today ? t('expired') : x.v ? t('gift_until', { date: day(x.until) }) : t('gift_open');
    return '<li><div><b>' + esc(prize(x)) + '</b><small>' + esc(day(x.at)) + ' · ' + esc(st) + '</small></div>' + extra + '</li>';
  }
  function renderWins() {
    var list = (S && S.wins) || [];
    winsBox.hidden = !list.length;
    winsEl.innerHTML = list.map(winLine).join('');
  }
  function render(s) {
    S = s || {};
    root.classList.toggle('is-off', !S.on);   /* slået fra (før lanceringen): kun overskriften og "pause" — test-kunder ser hjulet */
    renderOdds();
    if (!busy) {   /* ugens spin: hjulet står, hvor det landede (feltet fremhævet) — ellers hjulet, som det ser ud nu */
      var mine = S.spin && S.spin.lay, L = mine ? keys(S.spin.lay) : keys(S.wheel && S.wheel.L);
      if (mine && S.spin.id !== spunId) rot = -((Number(S.spin.k) + 0.5) * 360 / Math.max(1, L.length));
      draw(L, mine ? Number(S.spin.k) : -1);
    }
    renderSide(); renderWins();
  }
  function fail() { side.innerHTML = p(t('error')) + soundBtn(); }
  function load() {
    var pre = w.__pbMw; w.__pbMw = null;
    return (pre || fetch('/apps/pb/mw?cur=' + encodeURIComponent(cur), { cache: 'no-store', credentials: 'same-origin' }).then(function (r) { return r.json(); })).then(render).catch(fail);
  }
  function post(path, data) { return fetch('/apps/pb/mw/' + path, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data || {}) }).then(function (r) { return r.json(); }); }
  /* gaven i kurven: præcis ét stk. pr. gyldigt krav (fødselsdagen + hjulets gaver, PB.cfg.member.bc/wg) — samme regel som
     kassen (member-guard). Et skiftet brand tages ud af kurven, og et klik mere lægger ikke en gave til. */
  function putGift(v) {
    var mb = (w.PB && PB.cfg && PB.cfg.member) || {}, today = (S && S.today) || new Date().toISOString().slice(0, 10), need = {}, have = {}, upd = {}, any = false;
    var J = { 'Content-Type': 'application/json', Accept: 'application/json' };
    function live(x) { return !!x && !!x.v && x.used !== true && (!x.until || today <= x.until); }
    function ok(r) { if (!r.ok) throw new Error('cart'); return r; }
    if (mb.bc && mb.bc.c === 'gift' && live(mb.bc)) need[mb.bc.v] = (need[mb.bc.v] || 0) + 1;
    (mb.wg || []).forEach(function (x) { if (live(x)) need[x.v] = (need[x.v] || 0) + 1; });
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(ok).then(function (r) { return r.json(); }).then(function (c) {
      (c.items || []).forEach(function (i) {
        if (!mb.bg || Number(i.product_id) !== Number(mb.bg)) return;
        var k = String(i.variant_id), q = Math.min(i.quantity, Math.max(0, (need[k] || 0) - (have[k] || 0)));
        have[k] = (have[k] || 0) + q; if (q !== i.quantity) { upd[i.key] = q; any = true; }
      });
      if (any) return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: J, body: JSON.stringify({ updates: upd }) }).then(ok);
    }).then(function () {
      if ((have[v] || 0) >= (need[v] || 1)) return;
      return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: J, body: JSON.stringify({ items: [{ id: v, quantity: 1 }] }) }).then(ok);
    });
  }

  /* =================== ET SPIN =================== */
  function spinTo(s, done) {
    var L = keys(s.lay), n = L.length, k = Number(s.k), seg = 360 / n;
    hideReveal(); draw(L, -1);
    var target = -((k + 0.5) * seg + (Math.random() - 0.5) * seg * 0.6);
    var now0 = ((rot % 360) + 360) % 360, delta = ((target - now0) % 360 + 360) % 360;
    var from = rot, to = rot + 360 * 6 + delta, t0 = performance.now(), MS = reduced() ? 900 : (S.spinMs || 7000), last = null;
    (function frame(now) {
      var q = Math.min(1, (now - t0) / MS), e = 1 - Math.pow(1 - q, 4);
      rot = from + (to - from) * e; paint();
      var under = Math.floor((((-rot % 360) + 360) % 360) / seg);
      if (under !== last) { if (last !== null) tick(Math.pow(1 - q, 3)); last = under; }
      if (q < 1) { requestAnimationFrame(frame); return; }
      cv.setAttribute('data-rot', (((rot % 360) + 360) % 360).toFixed(2));
      draw(L, k); done();
    })(t0);
  }
  function hideReveal() { rev.hidden = true; rev.classList.remove('is-on'); }
  function reveal(s) {
    var r = result(s, true), nit = s.kind === 'nit';
    rev.className = 'pb-mw__reveal' + (nit ? ' is-nit' : '');
    rev.innerHTML = '<span>' + esc(nit ? t('this_week') : t('won')) + '</span><b>' + esc(nit ? t('p_nit') : r.h) + '</b><small>' + esc(r.x) + '</small>';
    rev.hidden = false; void rev.offsetWidth; rev.classList.add('is-on');
    if (nit) blank(); else { confetti(); landed(); }
    setTimeout(hideReveal, 6000);
  }
  function spin(b) {
    if (busy) return; busy = true; b.disabled = true; b.textContent = t('spinning');
    if (sound && audio() && A.c.state === 'suspended') A.c.resume();
    var f = side.querySelector('[data-pb-mw-force]');
    post('spin', f && f.value ? { cur: cur, force: f.value } : { cur: cur }).then(function (j) {
      if (!j || !j.ok) { busy = false; if (j && j.error === 'done') return load(); side.insertAdjacentHTML('afterbegin', p(t('error'))); b.disabled = false; b.textContent = t('spin'); return; }
      S.spin = j.spin; S.can = false; spunId = j.spin.id;
      spinTo(j.spin, function () { reveal(j.spin); busy = false; load(); });
    }).catch(function () { busy = false; fail(); });
  }

  /* =================== KLIK =================== */
  side.addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b) return;
    if (b.hasAttribute('data-pb-mw-spin')) return spin(b);
    if (b.hasAttribute('data-pb-mw-sound')) {
      sound = !sound; b.classList.toggle('is-on', sound); b.setAttribute('aria-pressed', sound);
      try { w.localStorage.setItem('pb-mw-sound', sound ? '1' : '0'); } catch (x) {}
      if (sound && audio() && A.c.state === 'suspended') A.c.resume();
      return;
    }
    var gid = b.getAttribute('data-pb-mw-addgift');
    if (gid) {
      var box = b.closest('[data-pb-mw-gift]'), r = box && box.querySelector('input[type="radio"]:checked'); if (!r) return;
      b.disabled = true;
      post('gift', { s: Number(gid), variant: Number(r.value) }).then(function (j) {
        if (!j || !j.ok) { b.disabled = false; box.insertAdjacentHTML('beforeend', p(t('error'))); return; }
        try { var mb = PB.cfg.member; mb.wg = (mb.wg || []).filter(function (x) { return x.s !== j.s; }).concat([{ s: j.s, v: j.variant, until: j.until, used: false }]); } catch (x) {}
        return putGift(j.variant).then(function () {
          try { if (w.PB && PB.cart && PB.cart.refresh) PB.cart.refresh(); } catch (x) {}
          inCart(box, true); b.disabled = false;
          confetti();
        });
      }).catch(function () { b.disabled = false; box.insertAdjacentHTML('beforeend', p(t('error'))); });
    }
  });
  /* et andet brand valgt, mens gaven ligger i kurven → knappen kommer igen (gaven byttes, når der trykkes) */
  side.addEventListener('change', function (e) {
    var r = e.target, box = r && r.type === 'radio' && r.closest('[data-pb-mw-gift]');
    if (box) inCart(box, false);
  });
  root.addEventListener('click', function (e) {
    var c = e.target.closest('[data-pb-mw-copy]');
    if (c) {
      var code = c.getAttribute('data-pb-mw-copy'), ok = function () { c.textContent = t('copied'); setTimeout(function () { c.textContent = t('copy'); }, 1800); };
      try { navigator.clipboard.writeText(code).then(ok, ok); } catch (x) { ok(); }
      return;
    }
    var g = e.target.closest('[data-pb-mw-gocart]');
    if (g && w.PB && PB.cart && PB.cart.open) { e.preventDefault(); PB.cart.open(); }
  });
  load();
})();
